/**
 * A quick reusable no-operation. This gets used.. a lot
 */
export default () => {}
